<template>
  <div class="diadin">
    <div>
      <el-form :inline="true"  ref="form" :model="form">
  <el-form-item label="">
    <el-input v-model="form.searchValue" clearable :placeholder="$t('menu.cgwdpjmc')+'/'+$t('menu.cgwdpjbm')"></el-input>
  </el-form-item>
  <!-- <el-form-item label="分类">
    <el-select v-model="form.region" placeholder="请选择活动区域">
      <el-option label="区域一" value="shanghai"></el-option>
      <el-option label="区域二" value="beijing"></el-option>
    </el-select>
  </el-form-item> -->
   
   <el-form-item label="">
    <el-select v-model="form.mcSeriesModelId" filterable clearable :placeholder="$t('menu.xspjsscx')">
      <el-option v-for="(item,index) in rolelist" :key="index" :label="item.seriesModel" :value="item.id"></el-option>
     
    </el-select>
  </el-form-item>
   <el-form-item label="">
    <el-select v-model="form.status" clearable :placeholder="$t('menu.lsszt')">
      <el-option label="不可见" value="0"></el-option>
      <el-option label="可见" value="1"></el-option>
    </el-select>
  </el-form-item>
   <!-- <el-form-item label="">
    <el-select v-model="form.categoryId" clearable filterable :placeholder="$t('menu.xspjfl')">
      <el-option v-for="(item,index) in categorylist" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
    </el-select>
  </el-form-item> -->
   <el-form-item >
     <el-button type="primary" style="margin-bottom: 20px" @click="biao1()">{{ $t('menu.sousuo') }}</el-button>
  </el-form-item>
  </el-form>
    </div>
    <!-- <el-button type="primary" style="margin-bottom: 20px" @click="handleEdit()">添加配件</el-button> -->
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <!-- <el-table-column prop="partId" label="配件ID"></el-table-column> -->
      <!-- <el-table-column prop="partCode" label="配件编号"> </el-table-column> -->
      <el-table-column prop="partName" :label="$t('menu.cgwdpjmc')" width="190">
        <template slot-scope="scope">
          <div>{{ fuilemodeisa(scope.row.partName,scope.row.partName2) }}</div>
            <div>{{ scope.row.partCode }}</div>
       
       
        </template> </el-table-column>
    
      <el-table-column prop="categoryId" :label="$t('menu.xspjfl')" width="140"> 
        <template slot-scope="scope">
          <div >
            {{sxtitle(scope.row)  }}
          </div> 
        </template>
      </el-table-column>
       <el-table-column prop="mcSeriesModelId" :label="$t('menu.xspjsscx')"> 
        <template slot-scope="scope">
          <div v-if="scope.row.mcSeriesModelId!==null">
            {{ fuilemodeis(scope.row.mcSeriesModelId) }}
          </div> 
          <div v-else>
            -
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="accTypeIdLs" label="币种"> 
         <template slot-scope="scope">
         
            {{ cbtyt(scope.row.accTypeIdLs) }}
       
       
        </template>
        
      </el-table-column> -->
      
      <el-table-column prop="purchasePrice" :label="$t('menu.cbjg')"> 
         <template slot-scope="scope">
          {{ scope.row.purchasePrice }}
            {{ scsc }}
       
       
        </template>
      </el-table-column>
       <el-table-column prop="partName2" :label="$t('menu.xspjfy')" width="190"> </el-table-column>
      <el-table-column prop="salePrice" :label="$t('menu.xspjxsj')"> </el-table-column>
     
      <el-table-column prop="replaceLabourPrice"  :label="$t('menu.xspjghgs')" width="100"> </el-table-column>
      <el-table-column prop="repairLabourPrice"  :label="$t('menu.xspjwxgs')" width="100"> </el-table-column>
      <!-- <el-table-column prop="currentStock" label="当前库存"> </el-table-column>
      <el-table-column prop="safetyStock" label="库存下限"> </el-table-column> -->
      <el-table-column prop="status" width="90">
        <template slot="header" slot-scope="scope">
          <div>{{ $t('menu.lsszt') }}</div>
        </template>
        <template slot-scope="scope">
          <el-switch
          v-model="scope.row.status"
           active-color="#13ce66"
           :active-value="1"
           :inactive-value="0"
           @change="putacc(scope.row)"
            inactive-color="#dcdfe6">
          </el-switch>
          
        </template>
      </el-table-column>

      <el-table-column width="70">
        <template slot="header" slot-scope="scope" >
          <div>{{ $t('menu.Operation') }}</div>
        </template>

        <template slot-scope="scope">
          <el-button type="text" size="mini"  @click="bianji(scope.row)" style="font-weight: 400;">{{
            $t('menu.Edit') }}</el-button>
         
          <!-- <el-button type="text" size="mini"  @click="erpzd( scope.ro)" style="font-weight: 400;">{{
            $t('menu.erpzd') }}</el-button>
             -->
        </template>
      </el-table-column>
    </el-table>
    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>
    </div>
    <el-dialog :title="$t('menu.Edit')" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
      <div class="ccca" style=" margin: 0 auto;">
        <el-form ref="formInline" :model="formInline" >
            <el-form-item  :label="$t('menu.cgwdpjbm')" >
              <el-input v-model="formInline.partCode" disabled ></el-input>
           </el-form-item>
            <el-form-item  :label="$t('menu.cgwdpjmc')" >
              <el-input v-model="formInline.partName" disabled ></el-input>
           </el-form-item>
             
            <el-form-item required :label="$t('menu.xspjfy')" >
              <el-input v-model="formInline.partName2" :disabled="false" ></el-input>
           </el-form-item>
            <el-form-item required :label="$t('menu.cbjg')+'('+scsc+')' " >
              <el-input v-model="formInline.purchasePrice" :disabled="true" ></el-input>
           </el-form-item>
            <el-form-item required :label="$t('menu.xspjxsj')+'('+cbtyt(formInline.accTypeIdLs)+')'" >
              <el-input v-model="formInline.salePrice" :disabled="false" ></el-input>
              
           </el-form-item>
            
           
            <el-form-item required :label="$t('menu.MinimumPurchaseQuantitya')" >
              <el-input v-model="formInline.minPurchaseQuantity" :disabled="false" ></el-input>
           </el-form-item>
            <el-form-item required :label="$t('menu.xspjghgs')+'('+cbtyt(formInline.accTypeIdLs)+')' " > 
              <el-input v-model="formInline.replaceLabourPrice" :disabled="false" ></el-input>
           </el-form-item>
            <el-form-item required :label="$t('menu.xspjwxgs')+'('+cbtyt(formInline.accTypeIdLs)+')' " >
              <el-input v-model="formInline.repairLabourPrice" :disabled="false" ></el-input>
           </el-form-item>
            <!-- <el-form-item  :label="$t('menu.zckckcxx')">
              <el-input v-model="formInline.safetyStock" :disabled="false" ></el-input>
           </el-form-item> -->
           <el-form-item  :label="$t('menu.zckcdqkc')">
              <el-input v-model="formInline.currentStock" :disabled="false" ></el-input>
           </el-form-item>
           <el-form-item  :label="$t('menu.zckckcxx')">
              <el-input v-model="formInline.safetyStock" :disabled="false" ></el-input>
           </el-form-item>
           <el-form-item  :label="$t('menu.Remarks')">
              
           </el-form-item>
           <el-form-item style="height: 600px;">
           
                 <quill-editor ref="quill" style="height: 400px;" v-model="formInline.remark" class="editor" :options="editorOption"/>
                 <input type="file" @change="change" id="upload" style="display:none;" />
            
           </el-form-item>
            <el-form-item >
              <div style=" margin: 30px auto" class="er">
          <el-button  type="primary" @click="updata"
            class="er">{{ $t('menu.Confirm') }}</el-button>
       

        </div>
           </el-form-item>
             
        </el-form>
      
       
      </div>
    </el-dialog>


    
  </div>
</template>

<script>
import { partRetailerOfDealer, listMcSeriesModels,pageQueryPartCategory, putdealerUser,putOfDealer,upload,deleOfDealer,listAccType,querytype } from "../../api/api";
import { quillEditor, Quill } from 'vue-quill-editor';
import { container, ImageExtend } from 'quill-image-extend-module'
import {quillRedefine} from 'vue-quill-editor-upload'
Quill.register('modules/ImageExtend', ImageExtend)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
   components:{
      quillEditor,quillRedefine
  },
  data () {
    return {
   
    
      dialogVisible: false,
      rolelist: [],
    editorOption: {
          modules: {
          ImageExtend: {
              loading: true,  // 可选参数 是否显示上传进度和提示语
              name: 'img',  // 图片参数名
              size: 3,  // 可选参数 图片大小，单位为M，1M = 1024kb
              action: upload,  // 服务器地址, 如果action为空，则采用base64插入图片
              // response 为一个函数用来获取服务器返回的具体图片地址
              // 例如服务器返回{code: 200; data:{ url: 'xxx.com'}}
              // 则 return res.data.url
              response: (res) => {
                console.log(res);
                return res.data.data
              },
          
          },
          toolbar: {
            container: container,  // container为工具栏，此次引入了全部工具栏，也可自行配置
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector('#upload').click()  // 劫持原来的图片点击按钮事件
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
    
    
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
     
      mation: [], //列表
      formInline: {
         partCode: '',
         accTypeIdLs:'',
        partName: "",
        partName2: "",
        purchasePrice:'',
        minPurchaseQuantity: "",
        replaceLabourPrice:'',
        repairLabourPrice:'',
        currentStock:'',
        safetyStock:'',
       salePrice:'',
       remark:'',
      },
   
      acclist:[],
      form:{
        searchValue:'',
        mcSeriesModelId:'',
        status:'',
        categoryId:''
      },
      categorylist:[],
      scsc:'',
      inle:'',
      
    };
  },
  created () {
    this.biao();
    this.role()
    this.acc()
    this.getQuerytype()
    this.scsc=sessionStorage.getItem('shbz')
     let a = sessionStorage.getItem('i18n')
    this.inle = a
  },
  computed: {

  },
  methods: {
     sxtitle(e){
      let a =''
        console.log(11,e);
        
      if(this.inle=='zh'){
        a=e.categoryName
      }
    if(this.inle=='en'){
      if(e.categoryNameEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.categoryNameEn)
     
        a=c.en
      }else{
        a=e.categoryNameEn
      }
      

      }
      if(this.inle=='de'){
         if(e.categoryNameEn.indexOf(":") !== -1){
             let d =JSON.parse(e.categoryNameEn)
        a=d.de
         } else{
        a=e.categoryNameEn
      } 
         
      
      }
      return a

    },
     change(e) {
        console.log(e);
        
      let file = e.target.files[0]
      const formData = new FormData()
       formData.append('category',e.target.files[0].type)
      formData.append('file', file)
       
      upload(formData)
        .then(res => {
       
          if (res.data.code == 200) {
            console.log(1,this.$refs.quill);
               let quill = this.$refs.quill.quill
               console.log(2,this.$refs.quill);
               
            // const formdata = _.extend({}, this.formdata)
            let length = quill.getSelection().index//光标位置
            // 插入图片  图片地址
            quill.insertEmbed(length, 'image', res.data.data)
            // 调整光标到最后
            quill.setSelection(length + 1)//光标后移一位
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    //过滤车型
    fuilemodeis(e){
      let a =this.rolelist
      let b =''
      a.forEach(z=>{
        if(z.id==e){
       
          
            if(this.inle=='zh'){
             b=z.seriesModel
          }else{
            console.log();
            
            b=z.seriesModelEn
          }
         
        }
      })
      return b 
    },
    fuilemodeisa(e,i){
    let b =''
            if(this.inle=='zh'){
             b=e
          }else{
            b=i
          }
         
      
      return b 
    },
   
   async acc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
   

    },
    cbtyt(e){
      let a =this.acclist
      let b =''
      a.forEach(z=>{
        if(z.id==e){
          b=z.currencyName
        }
      })
      return b
    },
    handleClose () {
      this.formInline = {
       partCode: '',
        partName: "",
        partName2: "",
        accTypeIdLs:'',
        purchasePrice:'',
        minPurchaseQuantity: "",
        replaceLabourPrice:'',
        repairLabourPrice:'',
        currentStock:'',
        safetyStock:'',
        salePrice:'',
       
      }
    
      this.dialogVisible = false
    

    },
    //编辑按钮
    bianji(e){ 
      this.formInline={...e}
      this.dialogVisible=true
     
    },
 
    biao1(){
      this.currentPage3=1
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
       
      let mcSeriesModelId=this.form.mcSeriesModelId
      let searchKey=this.form.searchValue
      let categoryId=this.form.categoryId
      let status =this.form.status

      const { data: res } = await partRetailerOfDealer(
        param,
        this.currentPage3,
        this.pagesize,
        mcSeriesModelId,
        searchKey,
        categoryId,
        status
      );
      console.log(res);

      this.mation = res.rows;
      this.totale = res.total;
    },

    //车型
    async role () {
        let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModels(param);


      this.rolelist = res.data;


    },
 
     async putacc(e){
      console.log(123,e);
      
      //  e.minPurchaseQuantity=1
      if (e.status==1&&e.salePrice==null){
        this.$message({
          message: '请先配置销售价格',
          type: 'error'
        });
         this.biao()
        return false
      }
       let param =e 

        const { data: res } = await putOfDealer( param );
        if(res.code==500){
       this.$message({
          message: res.msg,
          type: 'error'
        });
    this.biao()
    }else{
       this.handleClose()
           this.biao()
    }
     },
    //编辑
    async updata () {
   
    
    let param =this.formInline
    
    const { data: res } = await putOfDealer( param );
    if(res.code==500){
       this.$message({
          message: res.msg,
          type: 'error'
        });
    this.biao()
    }else{
        this.$message({
          message: this.$t('menu.caozuochengong'),
          type: 'success'
        });
         this.handleClose()
         this.biao()
    }
        
       

    },
    //分类
   async getQuerytype () {
    //  const params = new URLSearchParams()
     
     let param=''
       const { data: res } = await pageQueryPartCategory(param,1,2000,'','')
    //  querytype( params, 't_part_category').then(r => {
 
      this.categorylist = res.data.list;
     

    //  })
     },
    cist(e){
      let a =''
      this.categorylist.forEach(z=>{
        if(z.id==e){
          console.log(123123,z);
          
            this.sxtitle(z)
          
        }
      })
      return a
    },

    //删除
    async dele(e){
      let param=''
       const { data: res } = await deleOfDealer(param,e)
        if (res.code !== 200) return this.$message.error(res.msg)
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        
        this.biao()
    },
    //编辑账号 
    async putdata () {
    
        let param = this.formInline
        param.roleIds = [param.roleIds]

        const { data: res } = await putdealerUser(param)
        if (res.code !== 200) return this.$message.error("添加失败")
        this.$message({
          message: '添加成功',
          type: 'success'
        });
        this.handleClose()
        this.biao()
    

    },


    //表单点击

    handleEdit () {
     this.$router.push('/Access')
    },

 

    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.pagesize=val
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3=val
      this.biao();
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.ccca {
  width: 600px;
}

.er {
  width: 200px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 20px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-form-item {
  margin-bottom: 0 !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-form-item__label {
  text-align: left !important;
}

/deep/.el-table th.is-leaf {
  text-align: left;
  // background-color: #d7d7d7;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
}

/deep/.el-form-item__content {
  margin-left: 0 !important;
}
</style>